// packages/services/src/productService.ts
import { Product } from '../types/Product';

import { dataService } from './core/dataService';

export const productService = {

  
    get baseService() {
        return dataService<Product>("products");
    },

  
};